export const iconFontAwesomeChildhoodHandsHoldingChild = (
	<i className="fa-solid fa-hands-holding-child"></i>
);
